import { useContext, useEffect, useRef, useState } from "react";
import {
  ContainerNivelGrade,
  GradeNivel,
  GradeStyled,
  MarcadoresNivel,
  TextoVertical,
  TextoVertical1,
} from "../../Styles/Grade";
import { Footer } from "../../components/Footer";
import { Header, HeaderMobil } from "../../components/Header";
import { LogoBG } from "../../components/logoBG";
import { HomeContext } from "../../Context/ContextHome";
import { apiSae } from "../../services/api";
import { useParams } from "react-router-dom";
import { GradeContext } from "../../Context/ContextGrade";
import { SquareLoading } from "../../components/loaders";
import {
  AiFillAlert,
  AiOutlineAlert,
  AiTwotoneAlert,
  AiTwotoneQuestionCircle,
} from "react-icons/ai";
import {
  CxControle,
  EventosFalhasStyled,
  ModalStyledAvisoEmergencia,
} from "../../Styles/Elevatoria";
import { IoClose } from "react-icons/io5";
import { TbArrowBackUp } from "react-icons/tb";

import GradeimgOff from "../../Assets/Icons/GradeOff.png";
import GradeimgON1 from "../../Assets/Icons/GradeOn_A.png";
import GradeimgON2 from "../../Assets/Icons/GradeOn_B.png";
import GradeimgON3 from "../../Assets/Icons/GradeOn_C.png";

import TraspotadorImg from "../../Assets/Icons/transportadorOFF.png";
import TraspotadorImgOn from "../../Assets/Icons/transportadorON.png";
import { GraficoPoco } from "../Elevatoria/Graficos";
import { formatInTimeZone } from "date-fns-tz";
import { GraficoPocograde, ModalCalendarioGrafico } from "./Graficos";
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdCloseCircleOutline,
} from "react-icons/io";
import { ModalSelecaoPeriodo } from "../Elevatoria";
import jsPDF from "jspdf";
import {
  ModalRelatorioBombaStyled,
  ModalRelatoriosStyled,
} from "../../Styles/Modals";
import { format } from "date-fns";
import DatePicker from "react-datepicker";

export const Grade = () => {
  const { codigo_estacao } = useParams();
  const { headerApi, infoUser, socket, userOn, navigate } =
    useContext(HomeContext);
  const {
    listarEventos,
    modalAvisosEmegencia,
    setModalAvisosEmegencia,
    eventos,
    modalEventosFalhas,
    setModalEventosFalhas,
    modalRelatorioGradeOn,
    setModalRelatorioGradeOn,
    modalGraficoOpen,
    setIdDataGrade,
  } = useContext(GradeContext);

  const imagensOn = useRef([GradeimgON1, GradeimgON2, GradeimgON3]);

  const imagemOff = GradeimgOff;

  const [loading, setLoading] = useState(false);
  const [idEstacao, setIdEstacao] = useState(null);
  const [idGrade, setIdGrade] = useState(null);
  const [GradeS, setGrade] = useState({});
  const [alerEmergenciaList, setAlerEmergenciaList] = useState([]);
  const [statusPoco, setStatusPoco] = useState([]);
  const [dispositivoLigado, setDispositivoLigado] = useState(false);

  const [indiceAtual, setIndiceAtual] = useState(0);
  const intervaloRef = useRef(null);

  const timeEspera = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm");
  };

  const formatDate = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "dd/MM/yyyy");
  };

  const aoListarIdEstacao = async () => {
    try {
      const listarEstacao = await apiSae.get(`estacao/leituratodos`, headerApi);
      const idEstacao = listarEstacao.data.find(
        (e) => codigo_estacao === e.codigo
      );

      if (!idEstacao) {
        navigate("/");
        return;
      }
      setIdGrade(idEstacao.grades[0].id);
      setIdEstacao(idEstacao.id);
      return idEstacao.id;
    } catch (error) {
      console.log(error);
    }
  };

  const aoListarGrade = async () => {
    setLoading(true);
    try {
      let idEstacaoSalve = null;
      idEstacaoSalve = await aoListarIdEstacao();
      if (!idEstacaoSalve) {
        idEstacaoSalve = await aoListarIdEstacao();
      }

      if (!idEstacaoSalve) {
        return;
      }

      const Response = await apiSae.get(
        `estacao/leitura/${idEstacaoSalve}`,
        headerApi
      );
      setGrade(Response.data);
      listarEventos(idEstacaoSalve);
      // ListAlerts(idEstacaoSalve);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const ListAlerts = async (idSaveFuncao) => {
    try {
      if (idSaveFuncao === null) {
        idSaveFuncao = await aoListarIdEstacao();
      }
      const AlertaList = await apiSae.get(
        `/avisoEmergencia/listEstacao/${idSaveFuncao}`,
        headerApi
      );
      setAlerEmergenciaList(AlertaList.data);
    } catch (error) {
      console.log(error);
    }
  };

  const verifStatusGtwPoco = async (idGTw) => {
    try {
      if (idGTw != null) {
        const status = await apiSae.get(`/users/gtw/${idGTw}`, headerApi);
        return status.data.online;
      }
    } catch (error) {
      return false;
    }
  };

  const fetchStatuses = async () => {
    await timeEspera(100);

    try {
      const newStatuses = {};
      let idEstcaoSalve = idEstacao;
      if (!GradeS.grades) {
        if (idEstcaoSalve) {
          const Response = await apiSae.get(
            `estacao/leitura/${idEstcaoSalve}`,
            headerApi
          );
          if (
            Response.data.hasOwnProperty("grades") &&
            Response.status === 200
          ) {
            for (const grade of Response.data.grades || []) {
              newStatuses[grade.id] = await verifStatusGtwPoco(grade.gtw_poco);
            }
          }
        } else {
          const idEstacao = await aoListarIdEstacao();
          const Response = await apiSae.get(
            `estacao/leitura/${idEstacao}`,
            headerApi
          );
          if (
            Response.data.hasOwnProperty("grades") &&
            Response.status === 200
          ) {
            for (const grade of Response.data.grades || []) {
              newStatuses[grade.id] = await verifStatusGtwPoco(grade.gtw_poco);
            }
          }
        }
      } else {
        for (const grade of GradeS.grades || []) {
          newStatuses[grade.id] = await verifStatusGtwPoco(grade.gtw_poco);
        }
      }
      setStatusPoco(newStatuses);
    } catch (error) {
      console.log(error);
    }
  };

  const calcularPorcentagem = (valorAtual, valorMaximo) => {
    return (valorAtual / valorMaximo) * 100;
  };

  useEffect(() => {
    imagensOn.current.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
    const offImg = new Image();
    offImg.src = imagemOff;
  }, []);

  useEffect(() => {
    // update_ControlerBomba
    if (socket) {
      socket.on("update_grade", () => {
        aoListarGrade();
      });
      socket.on("creat_alerta", () => {
        aoListarGrade();
      });
      socket.on("update_avisoEmergencia", () => {
        ListAlerts(idEstacao);
      });
    }
  }, [socket]);

  useEffect(() => {
    fetchStatuses();
  }, [userOn]);

  useEffect(() => {
    aoListarGrade();
    ListAlerts(idEstacao);
  }, []);

  // Inicia/parar a animação conforme o estado
  useEffect(() => {
    if (dispositivoLigado) {
      intervaloRef.current = setInterval(() => {
        setIndiceAtual((prev) => (prev + 1) % imagensOn.current.length);
      }, 280); // tempo por frame (200ms)
    } else {
      clearInterval(intervaloRef.current);
      setIndiceAtual(0); // resetar pra primeira frame ou tanto faz
    }

    return () => clearInterval(intervaloRef.current);
  }, [dispositivoLigado]);

  const imagemSrc = dispositivoLigado
    ? imagensOn.current[indiceAtual]
    : imagemOff;

  const eventosList = eventos.results;

  const ultimosEventos = eventosList.slice(0, 10);

  return (
    <GradeStyled>
      {/* {loading && <SquareLoading />} */}
      {modalAvisosEmegencia && <ModalAvisoEmergencia idEstcao={idEstacao} />}
      {modalEventosFalhas && <ModalsEventoFalha idEstacao={idEstacao} />}
      {modalRelatorioGradeOn && <ModalRelatorios elevatoria={GradeS} />}
      {modalGraficoOpen && <ModalCalendarioGrafico />}
      <Header pgAdmin={true} />
      <HeaderMobil pgAdmin={true} />
      <LogoBG />
      <div className="IconAlerte">
        <button onClick={() => setModalAvisosEmegencia(true)}>
          {alerEmergenciaList.length > 0 ? (
            alerEmergenciaList.some(
              (alerta) => alerta.status === "pendente"
            ) ? (
              <AiFillAlert className="iconStyledAlertEmegencia" />
            ) : (
              <AiTwotoneAlert className="iconStyledAlertPorcesso" />
            )
          ) : (
            <AiOutlineAlert className="iconStyledAlert" />
          )}
        </button>
      </div>
      <ul className="GradeUl">
        {GradeS.grades &&
          GradeS.grades.map((grade, index) => {
            let StatusPocoOn = false;

            StatusPocoOn = statusPoco[grade.id];

            if (dispositivoLigado) {
              if (grade.grade_status === 0) {
                setDispositivoLigado(false);
              }
            } else {
              if (grade.grade_status === 1) {
                setDispositivoLigado(true);
              }
            }

            const alturaAtual = calcularPorcentagem(
              grade.nivel_atual,
              grade.altura_poco
            );

            const alturaMinima = calcularPorcentagem(
              grade.nivel_minimo,
              grade.altura_poco
            );

            const alturaDesligamento = calcularPorcentagem(
              grade.nivel_desligamento,
              grade.altura_poco
            );

            const alturaAcionamneto = calcularPorcentagem(
              grade.nivel_acionamento,
              grade.altura_poco
            );

            const alturaMaxima = calcularPorcentagem(
              grade.nivel_maximo,
              grade.altura_poco
            );

            return (
              <li key={grade.id} className="GradeLi">
                <span className="iconStyled">{grade.nome}</span>
                <div className="tituloPoco">
                  <div className="iconBack" onClick={() => navigate(-1)}>
                    <TbArrowBackUp />
                  </div>
                  <div className="tituloStatus">
                    <h3>{GradeS.nome_estacao}:</h3>
                    {GradeS.pocos.length > 1 && (
                      <h2 className="numeroPoco">Poço {index + 1}</h2>
                    )}
                    <div className={`statusPoco`}>
                      <span
                        className={`statusDisplay ${
                          StatusPocoOn == true ? "StatusOn" : "StatusOFF"
                        }`}
                      />
                      {StatusPocoOn == true ? <p>Online</p> : <p>Offline</p>}
                    </div>
                  </div>
                </div>
                <div className="conteinerGradeInfo">
                  <div className="nivelReal">
                    <TextoVertical>
                      {/* <TextoVerticalizado texto="NÍVeL - ATUAL" /> */}
                      <TextoVertical1>Nível Atual</TextoVertical1>
                    </TextoVertical>
                    <NivelVertical
                      porcentagem={Math.floor(alturaAtual)}
                      largura="40px"
                    />
                    <MarcadoresNivel altura={Math.floor(alturaMaxima)}>
                      ------- Máx
                    </MarcadoresNivel>
                    <MarcadoresNivel altura={Math.floor(alturaAcionamneto)}>
                      ------- Acionamento
                    </MarcadoresNivel>
                    <MarcadoresNivel altura={Math.floor(alturaDesligamento)}>
                      ------- Desligamento
                    </MarcadoresNivel>
                    <MarcadoresNivel altura={Math.floor(alturaMinima)}>
                      ------- Mín
                    </MarcadoresNivel>
                    {/* <h3>Nivel Atual</h3> */}
                  </div>
                  <div className="GradeInfo">
                    <div
                      className={`StatusAutomatico ${
                        grade.automatico === 0 && "StatusAutomaticoManual"
                      }`}
                    >
                      <span>{grade.automatico === 1 ? "AUTO" : "MANUAL"}</span>
                    </div>
                    <div
                      className="statusGrade"
                      onClick={() => setDispositivoLigado((ligado) => !ligado)}
                    >
                      <img className="imgGrade" src={imagemSrc} alt="" />
                    </div>
                    <ul className="statusGradeUl">
                      <li>
                        <span>Grade</span>
                        <div className={grade.grade_status == 1 && "gradeOn"}>
                          {grade.grade_status == 1 ? "ON" : "OFF"}
                        </div>
                      </li>
                      <li>
                        <span>Limpeza</span>
                        <div className={grade.limpeza_status == 1 && "gradeOn"}>
                          {grade.limpeza_status == 1 ? "ON" : "OFF"}
                        </div>
                      </li>
                      <li>
                        <span>Trasporte</span>
                        <div
                          className={
                            grade.transportador_status == 1 && "gradeOn"
                          }
                        >
                          {grade.transportador_status == 1 ? "ON" : "OFF"}
                        </div>
                      </li>
                    </ul>
                    <div className="TrasporteInfo">
                      <div className="imgTrasporte">
                        <img
                          src={
                            grade.transportador_status === 1
                              ? TraspotadorImgOn
                              : TraspotadorImg
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="infoPocoGrafico">
                  <div className="BlocoInfoPoco">
                    <h3>{GradeS.nome_estacao}</h3>
                    <div className="dadosPoco">
                      <div className="dadosInfoPoco">
                        <p>Altura Atual do Poço</p>
                        <div className="cxInfoPoco">
                          {Math.floor(alturaAtual)}%
                        </div>
                      </div>
                      <div className="dadosInfoPoco">
                        <p>
                          Nível de Acionamento <br /> Grade I
                        </p>
                        <div className="cxInfoPoco">
                          {grade.nivel_acionamento} m
                        </div>
                      </div>
                    </div>
                    <div className="blocoControle">
                      <div className="controle">
                        <h3>Modo de Controle</h3>
                        <div className="divControler">
                          <CxControle
                            activo={
                              grade.automatico == 1
                                ? "var(--cor-infor)"
                                : "var(--branco)"
                            }
                          ></CxControle>
                          <p>Auto</p>
                        </div>
                        <div className="divControler">
                          <CxControle
                            activo={
                              grade.automatico == 2
                                ? "var(--cor-infor)"
                                : "var(--branco)"
                            }
                          ></CxControle>
                          <p>Remoto</p>
                        </div>
                        <div className="divControler">
                          <CxControle
                            activo={
                              grade.automatico == 0
                                ? "var(--cor-infor)"
                                : "var(--branco)"
                            }
                          ></CxControle>
                          <p>Manual</p>
                        </div>
                      </div>
                    </div>
                    <div className="blocoControle"></div>
                  </div>

                  <div className="blocoTabelaGrafico">
                    <div className="blocoTabelaConteiner">
                      <div className="blocoTabela">
                        <div className="tabela">
                          <table>
                            <thead>
                              <tr>
                                <th>Usuário</th>
                                <th>Data</th>
                                <th>Hora</th>
                                <th>Evento</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ultimosEventos.map((evento) => {
                                return (
                                  <tr key={evento.id}>
                                    <td>
                                      {evento.usuario.gateway
                                        ? "Localmente"
                                        : evento.usuario.nome}
                                    </td>
                                    <td>{formatDate(evento.createdAt)}</td>
                                    <td>{formatTime(evento.createdAt)}</td>
                                    <td className="mensagemTr">
                                      {evento.mensagem}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="botaoTabela">
                        <button
                          onClick={() => {
                            setModalEventosFalhas(true);
                          }}
                        >
                          Abrir Eventos
                        </button>
                        <button
                          onClick={() => {
                            setModalRelatorioGradeOn(true);
                            setIdDataGrade(grade.id);
                          }}
                        >
                          Relatórios
                        </button>
                      </div>
                    </div>
                    <GraficoPocograde
                      idPoco={grade.id}
                      altura={grade.altura_util_poco}
                    />
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
      <Footer background={true} relative={false} />
    </GradeStyled>
  );
};

export const ModalAvisoEmergencia = ({ idEstcao }) => {
  const { setModalAvisosEmegencia } = useContext(GradeContext);
  const { headerApi, infoUser, socket, userOn } = useContext(HomeContext);

  const [sectionSelect, setSectionSelect] = useState(true);
  const [alerEmergenciaList, setAlerEmergenciaList] = useState([]);
  const [alerEmergenciaListHistorico, setAlerEmergenciaListHistorico] =
    useState([]);

  const listHistorico = async () => {
    try {
      const response = await apiSae.get(
        `avisoEmergencia/listHistoricoEstacao/${idEstcao}`,
        headerApi
      );
      setAlerEmergenciaListHistorico(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const listAlerts = async () => {
    try {
      const response = await apiSae.get(
        `avisoEmergencia/listEstacao/${idEstcao}`,
        headerApi
      );
      setAlerEmergenciaList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const UpdateAlerta = async (statusAlert, idAlert) => {
    const status = {
      status: statusAlert,
    };
    try {
      const update = await apiSae.patch(
        `avisoEmergencia/${idAlert}`,
        status,
        headerApi
      );

      listAlerts();
    } catch (error) {}
  };

  useEffect(() => {
    let interval;

    if (sectionSelect) {
      listAlerts(); // Chama imediatamente ao ativar a seção

      interval = setInterval(() => {
        listAlerts();
      }, 60000); // Executa a cada 60 segundos (1 minuto)
    }

    return () => {
      clearInterval(interval); // Limpa o intervalo ao sair da seção
    };
  }, [sectionSelect]); // Dispara sempre que sectionSelect mudar

  useEffect(() => {
    if (socket) {
      socket.on("update_avisoEmergencia", () => {
        listAlerts();
      });
    }
  }, [socket]);

  return (
    <ModalStyledAvisoEmergencia>
      <div className="conteiner">
        <span
          className="Closemodal"
          onClick={() => setModalAvisosEmegencia(false)}
        >
          <IoClose />
        </span>

        <div className="SelectSections">
          <h2
            className={`${sectionSelect && "sectionAtive"}`}
            onClick={() => {
              setSectionSelect(true);
              listAlerts();
            }}
          >
            Alertas
          </h2>
          <h2
            className={`${!sectionSelect && "sectionAtive"}`}
            onClick={() => {
              setSectionSelect(false);
              listHistorico();
            }}
          >
            Histórico de Alertas
          </h2>
        </div>

        {sectionSelect ? (
          <section>
            {alerEmergenciaList.length > 0 ? (
              <ul className="ulHistorico">
                {alerEmergenciaList.map((alerta) => {
                  const dataErro = new Date(alerta.createdAt);
                  const agora = new Date();
                  const diffMs = agora - dataErro; // Diferença em milissegundos
                  const diffMin = Math.floor(diffMs / 60000); // Converter para minutos
                  const diffHoras = Math.floor(diffMin / 60);
                  const diffDias = Math.floor(diffHoras / 24);

                  let tempoDecorrido = "";
                  if (diffDias > 0) {
                    tempoDecorrido = `${diffDias} dia(s)`;
                  } else if (diffHoras > 0) {
                    tempoDecorrido = `${diffHoras} hora(s)`;
                  } else {
                    tempoDecorrido = `${diffMin} minuto(s)`;
                  }
                  return (
                    <li
                      className={`${
                        alerta.status === "pendente" ? "pedente" : "manuteçao"
                      }`}
                    >
                      <span className="iconStyled">
                        <AiOutlineAlert />
                      </span>
                      <div className="Status">
                        <span className="top">Status</span>
                        {alerta.status === "pendente" ? (
                          <span className="Statusalert">
                            Aguardando análise
                          </span>
                        ) : (
                          <span className="Statusalert">Em manutenção</span>
                        )}
                      </div>
                      <div className="Status">
                        <span className="top">Alerta</span>
                        <p> {alerta.descricao}</p>
                      </div>
                      <div className="Status">
                        <span className="top">Tempo Decorrido</span>
                        <span>{tempoDecorrido}</span>
                      </div>
                      <div className="Status">
                        <span className="top">Atualizar</span>
                        {alerta.status === "pendente" ? (
                          <button
                            className="buttonPendente"
                            onClick={() => {
                              UpdateAlerta("em_progresso", alerta.id);
                            }}
                          >
                            Entrar Em manutenção
                          </button>
                        ) : (
                          <button
                            className="buttonProgresso"
                            onClick={() => {
                              UpdateAlerta("resolvido", alerta.id);
                            }}
                          >
                            Problema Resolvido
                          </button>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="alertsOk">
                <h2>Nenhum alerta ativo. Tudo certo!</h2>
              </div>
            )}
          </section>
        ) : (
          <section className="historicoAlert">
            <ul className="ulHistorico">
              {alerEmergenciaListHistorico.map((alerta) => {
                return (
                  <li>
                    <span className="iconStyled">
                      <AiOutlineAlert />
                    </span>
                    <div className="Status">
                      <span className="top">Status</span>
                      <span>Resolvido</span>
                    </div>
                    <div className="Status">
                      <span className="top">Alerta</span>
                      <p> {alerta.descricao}</p>
                    </div>
                    <div className="Status">
                      <span className="top"> Início do Erro</span>
                      <span>
                        {new Date(alerta.createdAt).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>

                    <div className="Status">
                      <span className="top"> Data de Solução</span>
                      <span>
                        {new Date(alerta.updatedAt).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </section>
        )}
      </div>
    </ModalStyledAvisoEmergencia>
  );
};

const NivelVertical = ({
  altura = "100%",
  largura = "40px",
  porcentagem = 50,
}) => {
  return (
    <ContainerNivelGrade altura={altura} largura={largura}>
      <GradeNivel porcentagem={porcentagem} />
    </ContainerNivelGrade>
  );
};

export const ModalsEventoFalha = ({ idEstacao }) => {
  const { modalEventosFalhas, setModalEventosFalhas, eventos, listarEventos } =
    useContext(GradeContext);

  const [showModalOptions, setShowModalOptions] = useState(false);
  const [filteredEventos, setFilteredEventos] = useState(eventos);
  const [pageNumber, setPageNumber] = useState(1);
  const [listAlerta, setListAlerta] = useState([]);

  const formatDate = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "dd/MM/yyyy");
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm");
  };

  const filterEventos = (dataInicio, dataFim) => {
    const filtered = eventos.results.filter((evento) => {
      const eventoDate = new Date(parseInt(evento.createdAt, 10));

      return (
        eventoDate >= new Date(dataInicio) && eventoDate <= new Date(dataFim)
      );
    });

    setFilteredEventos({ results: filtered });
  };

  const listAlertas = async () => {
    const token = localStorage.getItem("tokenBrk");
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await apiSae.get(
        `/alertas/list/${idEstacao}`,
        headerApi
      );
      setListAlerta(response.data);
      return response.data;
    } catch (error) {}
  };

  const handleConfirm = async ({ dataInicio, dataFim, formato }) => {
    let eventosParaExportar = filteredEventos.results;
    const timeZone = "America/Sao_Paulo";

    let filterListerAlerta = listAlerta;

    if (dataInicio && dataFim) {
      filterEventos(dataInicio, dataFim);

      filterListerAlerta = listAlerta.filter((e) => {
        const alertDate = formatInTimeZone(e.createdAt, timeZone, "yyyy-MM-dd");
        return alertDate >= dataInicio && alertDate <= dataFim;
      });

      setListAlerta(filterListerAlerta);
    } else {
      setFilteredEventos({ results: eventos.results || [] }); // Se não houver data, mostra todos os eventos
    }
    if (formato === "pdf") {
      setListAlerta(filterListerAlerta);
      setTimeout(() => {
        exportToPDF(filterListerAlerta);
      }, 500);
    } else {
      exportToCSV(filterListerAlerta);
    }
  };

  const exportToPDF = async (dataList) => {
    const doc = new jsPDF();
    const tableColumn = ["Data", "Hora", "Evento / Falha", "lido"];

    // await listAlertas();

    const tableRows = dataList.map((evento) => [
      formatDate(evento.createdAt),
      formatTime(evento.createdAt),
      evento.mensagem,
      evento.lido ? "Sim" : "Não",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: "auto" },
      },
      theme: "grid",
    });

    doc.save(`Eventos_Falhas_${new Date().toLocaleDateString()}.pdf`);

    await listarEventos(idEstacao); // Aguarde listarEventos ser concluído
    setFilteredEventos(eventos); // Atualiza o estado com todos os eventos
    setPageNumber(1); // Reseta a página
  };

  const exportToCSV = async (dataList) => {
    const headers = "Data,Hora,Evento / Falha,lido\n";
    const csvRows = dataList;
    const exportToCSV = async () => {
      if (
        !filteredEventos ||
        !filteredEventos.results ||
        filteredEventos.results.length === 0
      ) {
        console.error("Nenhum dado disponível para exportar.");
        return;
      }

      const headers = "Data,Hora,Evento / Falha,lido\n";
      const csvRows = filteredEventos.results
        .map(
          (evento) =>
            `${formatDate(evento.createdAt)},${formatTime(evento.createdAt)},${
              evento.mensagem
            },${evento.lido}`
        )
        .join("\n");

      const csvString = headers + csvRows;
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Eventos_Falhas_${new Date().toLocaleDateString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      await listarEventos(idEstacao); // Aguarde listarEventos ser concluído
      setFilteredEventos(eventos); // Atualiza o estado com todos os eventos
      setPageNumber(1); // Reseta a página
    };
  };

  const alterPage = async (url) => {
    const token = localStorage.getItem("tokenBrk");
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await apiSae.get(
        `/alertas/leitura/${idEstacao}${url}`,
        headerApi
      );
      setFilteredEventos(response.data || { result: [] });
    } catch (error) {}
  };

  const handleCheckboxChange = async (evento) => {
    const token = localStorage.getItem("tokenBrk");
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      // Atualiza o evento para marcado como lido
      await apiSae.patch(
        `/alertas/${evento.id}`,
        { lido: !evento.lido },
        headerApi
      );

      // Atualiza o estado local
      setFilteredEventos((prevEventos) => ({
        ...prevEventos,
        results: prevEventos.results.map((e) =>
          e.id === evento.id ? { ...e, lido: !e.lido } : e
        ),
      }));
    } catch (error) {
      console.error("Erro ao atualizar evento:", error);
    }
  };

  useEffect(() => {
    listAlertas();
  }, []);

  return (
    <>
      {modalEventosFalhas && (
        <EventosFalhasStyled>
          <div className="container">
            <div className="cabecalho">
              <h3>Tabela de Eventos</h3>

              <span
                className="fechaModal"
                onClick={() => setModalEventosFalhas(false)}
              >
                <IoClose />
              </span>
            </div>
            <div className="tabelaGeral">
              <div className="tabela">
                <table>
                  <thead>
                    <tr>
                      <th>Usuário</th>
                      <th>Data</th>
                      <th>Hora</th>
                      <th>Evento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(filteredEventos.results || []).map((evento) => (
                      <tr key={evento.id}>
                        <td>
                          {evento.usuario.gateway
                            ? "Localmente"
                            : evento.usuario.nome}
                        </td>
                        <td>{formatDate(evento.createdAt)}</td>
                        <td>{formatTime(evento.createdAt)}</td>
                        <td>{evento.mensagem}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="setasPaginacao">
              <button
                className={filteredEventos.previous === null && "disable"}
                disabled={filteredEventos.previous === null}
                onClick={() => {
                  setPageNumber(pageNumber - 1);
                  alterPage(filteredEventos.previous);
                }}
              >
                <IoIosArrowBack />
              </button>
              <section>{pageNumber}</section>
              <button
                className={filteredEventos.next === null && "disable"}
                disabled={filteredEventos.next === null}
                onClick={() => {
                  setPageNumber(pageNumber + 1);
                  alterPage(filteredEventos.next);
                }}
              >
                <IoIosArrowForward />
              </button>
            </div>
            <button
              className="botaoEventos"
              onClick={() => setShowModalOptions(true)}
            >
              Download
            </button>
          </div>
        </EventosFalhasStyled>
      )}
      {showModalOptions && (
        <ModalSelecaoPeriodo
          onConfirm={handleConfirm}
          onCancel={() => setShowModalOptions(false)}
        />
      )}
    </>
  );
};

export const Modalrelatorio = ({ bombaId, data }) => {
  const { setModalRelatorioGradeOn } = useContext(GradeContext);

  const { headerApi } = useContext(HomeContext);
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mesSelecionado, setMesSelecionado] = useState(
    new Date().getMonth() + 1
  ); // 1-12
  const [anoSelecionado, setAnoSelecionado] = useState(
    new Date().getFullYear()
  );

  const meses = [
    { nome: "Janeiro", valor: 1 },
    { nome: "Fevereiro", valor: 2 },
    { nome: "Março", valor: 3 },
    { nome: "Abril", valor: 4 },
    { nome: "Maio", valor: 5 },
    { nome: "Junho", valor: 6 },
    { nome: "Julho", valor: 7 },
    { nome: "Agosto", valor: 8 },
    { nome: "Setembro", valor: 9 },
    { nome: "Outubro", valor: 10 },
    { nome: "Novembro", valor: 11 },
    { nome: "Dezembro", valor: 12 },
  ];

  const anos = [2023, 2024, 2025]; // Você pode gerar isso dinamicamente se quiser

  const getRelatorio = async () => {
    const year = data.getFullYear();
    const month = String(data.getMonth() + 1).padStart(2, "0");
    const day = String(data.getDate()).padStart(2, "0");
    setLoading(true);
    try {
      const response = await apiSae.get(
        `grade/registro/leitura/${bombaId}/${year}-${month}-${day}`,
        headerApi
      );
      setRelatorio(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatarTempo = (segundos) => {
    // Calculando horas, minutos e segundos
    const horas = Math.floor(segundos / 3600);
    segundos %= 3600;
    const minutos = Math.floor(segundos / 60);
    segundos %= 60;

    // Se o número de horas for maior que 0, mostramos em horas
    if (horas > 0) {
      return `${horas} hora${horas > 1 ? "s" : ""} ${minutos} minuto${
        minutos !== 1 ? "s" : ""
      }`;
    } else if (minutos > 0) {
      // Se não houver horas, mostramos apenas minutos
      return `${minutos} minuto${minutos !== 1 ? "s" : ""}`;
    } else {
      // Caso sejam menos de 60 segundos
      return `${segundos} segundo${segundos !== 1 ? "s" : ""}`;
    }
  };

  const mediaPorAcionamento = (
    numeroAcionamentos,
    totalSegundosTrabalhados
  ) => {
    if (numeroAcionamentos > 0) {
      const mediaSegundos = totalSegundosTrabalhados / numeroAcionamentos;
      const minutos = Math.floor(mediaSegundos / 60);
      const segundos = Math.floor(mediaSegundos % 60);
      return `${minutos}m ${segundos}s`;
    } else {
      return "0s";
    }
  };

  const generateReport = async (formatType) => {
    const tableColumn = [
      "Data",
      "Acionamentos",
      "horímetro do dia",
      "Média de tempo de funcionamento",
    ];

    const relatorioTotal = await apiSae.get(
      `/grade/registro/leitura-mensal/${bombaId}/${mesSelecionado}/${anoSelecionado}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .map((item) => [
        format(new Date(item.dataRegistro), "yyyy-MM-dd"),
        item.statusOff,
        formatarTempo(item.totalHorasTrabalhadas),
        mediaPorAcionamento(item.statusOff, item.totalHorasTrabalhadas),
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado}.pdf`
      );
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado} .csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    getRelatorio();
  }, []);

  return (
    <ModalRelatorioBombaStyled>
      <div className="Conteiner">
        <span
          className="closeModal"
          onClick={() => setModalRelatorioGradeOn(false)}
        >
          <IoMdCloseCircleOutline />
        </span>
        <h3>
          Relatório de Funcionamento da Bomba {data.getDate()}-
          {data.getMonth() + 1 <= 9
            ? `0${data.getMonth() + 1}`
            : data.getMonth() + 1}
        </h3>
        {relatorio ? (
          <ul>
            <li>
              <p>Horas em Funcionamento no Dia: </p>
              <div>
                <span className="resultsModal">
                  {formatarTempo(relatorio.totalHorasTrabalhadas)}
                </span>
              </div>
            </li>

            <li>
              <p>Média de tempo de funcionamento da bomba: </p>
              <div>
                <span className="resultsModal">
                  {mediaPorAcionamento(
                    relatorio.statusOff,
                    relatorio.totalHorasTrabalhadas
                  )}
                </span>
              </div>
            </li>
            <li>
              <p>Número total de acionamentos da bomba: </p>
              <div className="resultsModal">
                <span>{relatorio.statusOn}</span>
              </div>
            </li>
            <div className="selectRelatorio">
              <div>
                <label>Mês: </label>
                <select
                  value={mesSelecionado}
                  onChange={(e) => setMesSelecionado(Number(e.target.value))}
                >
                  {meses.map((mes) => (
                    <option key={mes.valor} value={mes.valor}>
                      {mes.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label>Ano: </label>
                <select
                  value={anoSelecionado}
                  onChange={(e) => setAnoSelecionado(Number(e.target.value))}
                >
                  {anos.map((ano) => (
                    <option key={ano} value={ano}>
                      {ano}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="buttonsRelatorio">
              <button
                onClick={() => {
                  generateReport("csv");
                }}
              >
                Download CSV
              </button>
              <button
                onClick={() => {
                  generateReport("pdf");
                }}
              >
                Download PDF
              </button>
            </div>
          </ul>
        ) : (
          <div className="noRelatorio">
            <span> Bomba nao possui relatorio desse dia </span>
          </div>
        )}
      </div>
    </ModalRelatorioBombaStyled>
  );
};

const ModalRelatorios = ({ elevatoria }) => {
  const {
    selectedDate,
    setSelectedDate,
    dataGrade,
    setDataGrade,
    idDataGrade,
    setIdDataGrade,
    loading,
    setLoading,
    setModalRelatorioGradeOn,
  } = useContext(GradeContext);

  const { headerApi } = useContext(HomeContext);

  const [selectRelatorio, setSelectRelatorio] = useState("Grade");
  const [opcaoSelecionada, setOpcaoSelecionada] = useState("dia");
  const [selectedDateBomba, setSelectedDateBomba] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);

    setDataGrade((prevDataPoco) => {
      const index = prevDataPoco.findIndex(
        (item) => item.id_poco === idDataGrade
      );

      if (index !== -1) {
        const updatedDataPoco = [...prevDataPoco];
        updatedDataPoco[index] = { ...updatedDataPoco[index], data: date };
        return updatedDataPoco;
      } else {
        return [...prevDataPoco, { id_poco: idDataGrade, data: date }];
      }
    });
  };

  const generateReport = async (formatType) => {
    const tableColumn = ["Data", "Hora", "Nivel"];

    const dataFormatada =
      dataGrade && dataGrade[0]?.data
        ? format(new Date(dataGrade[0].data), "dd-MM-yyyy")
        : format(new Date(), "dd-MM-yyyy");

    const relatorioTotal = await apiSae.get(
      `historico/grade/data/${idDataGrade}/${dataFormatada}/${opcaoSelecionada}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .reverse()
      .map((item) => [
        format(new Date(item.timestamp), "yyyy-MM-dd"),
        format(new Date(item.timestamp), "HH:mm"),
        item.nivel_atual,
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(`Relatório_de_NIvel.${format(new Date(), "yyyy-MM-dd")}.pdf`);
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_NIvel${format(new Date(), "yyyy-MM-dd")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const generateReportAcionamneto = async (formatType) => {
    const tableColumn = [
      "Data",
      "Acionamentos",
      "horímetro do dia",
      "Média de tempo de funcionamento",
    ];

    const relatorioTotal = await apiSae.get(
      `/grade/registro/leitura-mensal/${idDataGrade}/${mesSelecionado}/${anoSelecionado}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .map((item) => [
        format(new Date(item.dataRegistro), "yyyy-MM-dd"),
        item.statusOff,
        formatarTempo(item.totalHorasTrabalhadas),
        mediaPorAcionamento(item.statusOff, item.totalHorasTrabalhadas),
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado}.pdf`
      );
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado} .csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const mediaPorAcionamento = (
    numeroAcionamentos,
    totalSegundosTrabalhados
  ) => {
    if (numeroAcionamentos > 0) {
      const mediaSegundos = totalSegundosTrabalhados / numeroAcionamentos;
      const minutos = Math.floor(mediaSegundos / 60);
      const segundos = Math.floor(mediaSegundos % 60);
      return `${minutos}m ${segundos}s`;
    } else {
      return "0s";
    }
  };

  const formatarTempo = (segundos) => {
    // Calculando horas, minutos e segundos
    const horas = Math.floor(segundos / 3600);
    segundos %= 3600;
    const minutos = Math.floor(segundos / 60);
    segundos %= 60;

    // Se o número de horas for maior que 0, mostramos em horas
    if (horas > 0) {
      return `${horas} hora${horas > 1 ? "s" : ""} ${minutos} minuto${
        minutos !== 1 ? "s" : ""
      }`;
    } else if (minutos > 0) {
      // Se não houver horas, mostramos apenas minutos
      return `${minutos} minuto${minutos !== 1 ? "s" : ""}`;
    } else {
      // Caso sejam menos de 60 segundos
      return `${segundos} segundo${segundos !== 1 ? "s" : ""}`;
    }
  };

  const getRelatorio = async (bombasID, dataCalentadrio) => {
    setLoading(true);

    const year = dataCalentadrio.getFullYear();
    const month = String(dataCalentadrio.getMonth() + 1).padStart(2, "0");
    const day = String(dataCalentadrio.getDate()).padStart(2, "0");

    try {
      const response = await apiSae.get(
        `grade/registro/leitura/${bombasID}/${year}-${month}-${day}`,
        headerApi
      );

      setRelatorio(response.data);
    } catch (error) {
      if (error.response.status === 404) {
        setRelatorio(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDateChangeAcinamentos = (date) => {
    setSelectedDateBomba(date);
    getRelatorio(idDataGrade, date);
  };

  // ACINAMENTOS
  const [relatorio, setRelatorio] = useState(null);
  const [mesSelecionado, setMesSelecionado] = useState(
    new Date().getMonth() + 1
  ); // 1-12
  const [anoSelecionado, setAnoSelecionado] = useState(
    new Date().getFullYear()
  );

  const meses = [
    { nome: "Janeiro", valor: 1 },
    { nome: "Fevereiro", valor: 2 },
    { nome: "Março", valor: 3 },
    { nome: "Abril", valor: 4 },
    { nome: "Maio", valor: 5 },
    { nome: "Junho", valor: 6 },
    { nome: "Julho", valor: 7 },
    { nome: "Agosto", valor: 8 },
    { nome: "Setembro", valor: 9 },
    { nome: "Outubro", valor: 10 },
    { nome: "Novembro", valor: 11 },
    { nome: "Dezembro", valor: 12 },
  ];

  const anos = [2023, 2024, 2025]; // Você pode gerar isso dinamicamente se quiser

  return (
    <ModalRelatoriosStyled>
      <div className="conteiner">
        <span
          className="closeModal"
          onClick={() => setModalRelatorioGradeOn(false)}
        >
          <IoMdCloseCircleOutline />
        </span>
        <nav className="barSelect">
          <ul className="ulconteiner">
            <li
              className={selectRelatorio === "Grade" ? "select" : ""}
              onClick={() => setSelectRelatorio("Grade")}
            >
              Grade
            </li>
            <li
              className={selectRelatorio === "Acionamentos" ? "select" : ""}
              onClick={() => {
                setSelectRelatorio("Acionamentos");
                getRelatorio(idDataGrade, selectedDateBomba);
              }}
            >
              Acionamentos
            </li>
          </ul>
        </nav>

        {selectRelatorio === "Grade" && (
          <section className="PocoRelatorio">
            <div className="DataPoco">
              <h2>Selecionar Data</h2>
              <DatePicker
                className="agenda"
                selected={selectedDate}
                onChange={handleDateChange}
                inline
              />
              <div className="selectRelatorio">
                <label>Período do histórico: </label>
                <select
                // value={opcaoSelecionada} onChange={handleChange}
                >
                  <option value="dia">Dia</option>
                  <option value="mes">Mês</option>
                  <option value="ano">Ano</option>
                </select>
              </div>
              <div className="buttonsRelatorio">
                <button
                  onClick={() => {
                    generateReport("csv");
                  }}
                >
                  Download CSV
                </button>
                <button
                  onClick={() => {
                    generateReport("pdf");
                  }}
                >
                  Download PDF
                </button>
              </div>
            </div>
            <div className="GraficoPoco">
              <GraficoPocograde
                idPoco={idDataGrade}
                altura={elevatoria.grades[0].altura_poco}
              />
            </div>
          </section>
        )}
        {selectRelatorio === "Acionamentos" && (
          <section className="AcionamentosRelatorio">
            <div className="ConteinerAcinamesntos">
              <h3>
                Relatório de Funcionamento da Grade{" "}
                {selectedDateBomba.getDate()}-
                {selectedDateBomba.getMonth() + 1 <= 9
                  ? `0${selectedDateBomba.getMonth() + 1}`
                  : selectedDateBomba.getMonth() + 1}
              </h3>
              <div className="infoRelatorio">
                <div className="calendario">
                  <DatePicker
                    className="agenda"
                    selected={selectedDateBomba}
                    onChange={handleDateChangeAcinamentos}
                    inline
                  />
                </div>
                {relatorio ? (
                  <ul>
                    <li>
                      <p>
                        Horas em Funcionamento no Dia:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Total de horas que a bomba trabalhou na data
                            selecionada.
                          </span>
                        </span>
                      </p>
                      <div>
                        <span className="resultsModal">
                          {formatarTempo(relatorio.totalHorasTrabalhadas)}
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Média de tempo de funcionamento da bomba:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Média de tempo que a bomba ficou ligada em cada
                            acionamento durante o dia.
                          </span>
                        </span>
                      </p>
                      <div>
                        <span className="resultsModal">
                          {mediaPorAcionamento(
                            relatorio.statusOff,
                            relatorio.totalHorasTrabalhadas
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Número total de acionamentos da bomba:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Quantidade de vezes que a bomba foi ligada na data
                            selecionada.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>{relatorio.statusOn}</span>
                      </div>
                    </li>
                    <div className="selectRelatorio">
                      <div>
                        <label>Mês: </label>
                        <select
                          value={mesSelecionado}
                          onChange={(e) =>
                            setMesSelecionado(Number(e.target.value))
                          }
                        >
                          {meses.map((mes) => (
                            <option key={mes.valor} value={mes.valor}>
                              {mes.nome}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label>Ano: </label>
                        <select
                          value={anoSelecionado}
                          onChange={(e) =>
                            setAnoSelecionado(Number(e.target.value))
                          }
                        >
                          {anos.map((ano) => (
                            <option key={ano} value={ano}>
                              {ano}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="buttonsRelatorio">
                      <button
                        onClick={() => {
                          generateReportAcionamneto("csv");
                        }}
                      >
                        Download CSV
                      </button>
                      <button
                        onClick={() => {
                          generateReportAcionamneto("pdf");
                        }}
                      >
                        Download PDF
                      </button>
                    </div>
                  </ul>
                ) : (
                  <div className="noRelatorio">
                    <span> Grade nao possui relatorio desse dia </span>
                  </div>
                )}
              </div>
            </div>
          </section>
        )}
        {/* {selectRelatorio === "Acionamentos" && (
          <section className="AcionamentosRelatorio">
            <div className="selecBombas">
              <nav>
                <ul className="navBombas">
                  {elevatoria.pocos[0].bombas.map((bomba, index) => {
                    return (
                      <li
                        className={bomba.id == bombaId ? "selectButton" : ""}
                        onClick={() => {
                          getRelatorio(bomba.id, selectedDateBomba);
                          setBombaId(bomba.id);
                        }}
                      >
                        Bomba {index + 1}
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
            <div className="ConteinerAcinamesntos">
              <h3>
                Relatório de Funcionamento da Bomba{" "}
                {selectedDateBomba.getDate()}-
                {selectedDateBomba.getMonth() + 1 <= 9
                  ? `0${selectedDateBomba.getMonth() + 1}`
                  : selectedDateBomba.getMonth() + 1}
              </h3>
              <div className="infoRelatorio">
                <div className="calendario">
                  <DatePicker
                    className="agenda"
                    selected={selectedDateBomba}
                    onChange={handleDateChangeAcinamentos}
                    inline
                  />
                </div>
                {relatorio ? (
                  <ul>
                    <li>
                      <p>
                        Horas em Funcionamento no Dia:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Total de horas que a bomba trabalhou na data
                            selecionada.
                          </span>
                        </span>
                      </p>
                      <div>
                        <span className="resultsModal">
                          {formatarTempo(relatorio.totalHorasTrabalhadas)}
                        </span>
                      </div>
                    </li>

                    <li>
                      <p>
                        Média de tempo de funcionamento da bomba:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Média de tempo que a bomba ficou ligada em cada
                            acionamento durante o dia.
                          </span>
                        </span>
                      </p>
                      <div>
                        <span className="resultsModal">
                          {mediaPorAcionamento(
                            relatorio.statusOff,
                            relatorio.totalHorasTrabalhadas
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Número total de acionamentos da bomba:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Quantidade de vezes que a bomba foi ligada na data
                            selecionada.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>{relatorio.statusOn}</span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Vazão do dia:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Volume total de água bombeado no dia, considerando o
                            tempo de funcionamento e o desgaste da bomba.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>
                          {calcularVolumeTotal(
                            bombaSelecionada.vazaoNominal_Ls,
                            relatorio.totalHorasTrabalhadas,
                            relatorio.desgaste
                          )}
                          m³
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Vazão
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Vazão atual da bomba em litros por segundo (L/s),
                            ajustada com base no desgaste de desempenho.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>
                          {calcularVazaoCorrigida(
                            bombaSelecionada.vazaoNominal_Ls,
                            relatorio.desgaste
                          )}
                          .L/s
                        </span>
                      </div>
                    </li>
                    <div className="selectRelatorio">
                      <div>
                        <label>Mês: </label>
                        <select
                          value={mesSelecionado}
                          onChange={(e) =>
                            setMesSelecionado(Number(e.target.value))
                          }
                        >
                          {meses.map((mes) => (
                            <option key={mes.valor} value={mes.valor}>
                              {mes.nome}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label>Ano: </label>
                        <select
                          value={anoSelecionado}
                          onChange={(e) =>
                            setAnoSelecionado(Number(e.target.value))
                          }
                        >
                          {anos.map((ano) => (
                            <option key={ano} value={ano}>
                              {ano}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="buttonsRelatorio">
                      <button
                        onClick={() => {
                          generateReportAcionamneto("csv");
                        }}
                      >
                        Download CSV
                      </button>
                      <button
                        onClick={() => {
                          generateReportAcionamneto("pdf");
                        }}
                      >
                        Download PDF
                      </button>
                    </div>
                  </ul>
                ) : (
                  <div className="noRelatorio">
                    <span> Bomba nao possui relatorio desse dia </span>
                  </div>
                )}
              </div>
            </div>
          </section>
        )} */}

        <section></section>
      </div>
    </ModalRelatoriosStyled>
  );
};
